import React from "react";
import ReactDOM from "react-dom"; // Import ReactDOM
import { IoMdClose } from "react-icons/io";

const PopupDetail = ({ urlMessage, closePopup }) => {
  const popupContent = (
    <div className="popup-detail">
      <div className="popup-detail__content">
        <div className="popup-detail__close--container">
          <button className="popup-detail__close--btn" onClick={closePopup}>
            <IoMdClose />
          </button>
        </div>
        <iframe
          src={urlMessage}
          width="100%"
          height="100%"
          title="iframe URL"
        />
      </div>
    </div>
  );

  return ReactDOM.createPortal(popupContent, document.body);
};

export default PopupDetail;
